"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = Output;
const react_1 = __importDefault(require("react"));
function Output({ value, mediatype }) {
    if (mediatype === 'text/html') {
        return (react_1.default.createElement("div", { className: "output" },
            react_1.default.createElement("code", null, value)));
    }
    return react_1.default.createElement("div", { className: "output" }, value);
}
//# sourceMappingURL=Output.js.map